import backBtn from "../../assets/icons/back-btn.png";
import logo from "../../assets/doctio-logo.svg";
import fraseIkon from "../../assets/icons/Paper-icon + circle.svg";
import læge from "../../assets/people/TBV03834.png";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useState } from "react";
import { SignUpStep2Props } from "../../types/Signup/SignUpStep";
import Select from "react-tailwindcss-select";
import { SelectValue } from "react-tailwindcss-select/dist/components/type";
import { Link } from "react-router-dom";
import Stats from "../Stats/Stats";

type Option = {
  value: string;
  label: string;
  disabled?: boolean;
};

export default function SignUpStep2({
  prevStep,
  nextStep,
  statsData,
  signUpData,
  setSignUpData,
}: SignUpStep2Props) {
  const [isSigningUp, setIsSigningUp] = useState(false);
  const [profession, setProfession] = useState<Option | null>(null);
  const [specialty, setSpecialty] = useState<Option | null>(null);

  const handleInputChange = (value: SelectValue) => {
    if (value && typeof value === "object") {
      const selectedOption = value as Option;
      setProfession(selectedOption);
      setSignUpData({
        ...signUpData,
        profession: selectedOption.value,
      });
    }
  };

  const handleSpecialtyChange = (value: SelectValue) => {
    if (value && typeof value === "object") {
      const selectedOption = value as Option;
      setSpecialty(selectedOption);
      setSignUpData({
        ...signUpData,
        specialty: selectedOption.value,
      });
    }
  };

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSignUpData({
      ...signUpData,
      [event.target.name]: event.target.checked,
    });
  };

  const isFormValid =
    signUpData.confirm_health_professional &&
    signUpData.accept_terms_condition &&
    signUpData.profession !== "Fagprofil" &&
    signUpData.specialty !== "Speciale";

  const onClickNext = async () => {
    setIsSigningUp(true);

    try {
      const response = await fetch("https://test.doctio.dk/api/users", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(signUpData),
      });

      if (response.ok) {
        nextStep();
      } else {
        const responseData = await response.json();
        toast.error("Fejl: " + responseData.detail);
      }
    } catch (error) {
      console.error("Sign-up error:", error);
      toast.error("Der opstod en fejl under registrering.");
    } finally {
      setIsSigningUp(false);
    }
  };

  const professionOptions = [
    { value: "Læge", label: "Læge" },
    { value: "Tandlæge", label: "Tandlæge" },
    { value: "Farmaceut", label: "Farmaceut" },
    { value: "Sygeplejerske", label: "Sygeplejerske" },
    { value: "Farmakonom", label: "Farmakonom" },
    { value: "Jordemoder", label: "Jordemoder" },
    { value: "Bioanalytiker", label: "Bioanalytiker" },
    { value: "Kliniske diætist", label: "Kliniske diætist" },
    { value: "Radiograf", label: "Radiograf" },
    {
      value: "Social- og sundhedsassistent",
      label: "Social- og sundhedsassistent",
    },
  ];

  const specialtyOptions = [
    { value: "Akutmedicin", label: "Akutmedicin" },
    { value: "Almen medicin", label: "Almen medicin" },
    { value: "Anæstesiologi", label: "Anæstesiologi" },
    { value: "Arbejdsmedicin", label: "Arbejdsmedicin" },
    {
      value: "Børne- og ungdomspsykiatri",
      label: "Børne- og ungdomspsykiatri",
    },
    { value: "Dermatologi", label: "Dermatologi" },
    { value: "Endokrinologi", label: "Endokrinologi" },
    {
      value: "Gastroenterologi og hepatologi",
      label: "Gastroenterologi og hepatologi",
    },
    { value: "Geriatri", label: "Geriatri" },
    { value: "Gynækologi og obstetrik", label: "Gynækologi og obstetrik" },
    { value: "Hæmatologi", label: "Hæmatologi" },
    { value: "Infektionsmedicin", label: "Infektionsmedicin" },
    { value: "Kardiologi", label: "Kardiologi" },
    { value: "Karkirurgi", label: "Karkirurgi" },
    { value: "Kirurgi", label: "Kirurgi" },
    { value: "Klinisk biokemi", label: "Klinisk biokemi" },
    { value: "Klinisk farmakologi", label: "Klinisk farmakologi" },
    {
      value: "Klinisk fysiologi og nuklearmedicin",
      label: "Klinisk fysiologi og nuklearmedicin",
    },
    { value: "Klinisk genetik", label: "Klinisk genetik" },
    { value: "Klinisk immunologi", label: "Klinisk immunologi" },
    { value: "Klinisk mikrobiologi", label: "Klinisk mikrobiologi" },
    { value: "Klinisk onkologi", label: "Klinisk onkologi" },
    { value: "Lungemedicin", label: "Lungemedicin" },
    { value: "Nefrologi", label: "Nefrologi" },
    { value: "Neurokirurgi", label: "Neurokirurgi" },
    { value: "Neurologi", label: "Neurologi" },
    { value: "Oftalmologi", label: "Oftalmologi" },
    { value: "Ortopædkirurgi", label: "Ortopædkirurgi" },
    { value: "Patologi", label: "Patologi" },
    { value: "Plastikkirurgi", label: "Plastikkirurgi" },
    { value: "Psykiatri", label: "Psykiatri" },
    { value: "Pædiatri", label: "Pædiatri" },
    { value: "Radiologi", label: "Radiologi" },
    { value: "Retsmedicin", label: "Retsmedicin" },
    { value: "Reumatologi", label: "Reumatologi" },
    { value: "Samfundsmedicin", label: "Samfundsmedicin" },
    { value: "Thoraxkirurgi", label: "Thoraxkirurgi" },
    { value: "Urologi", label: "Urologi" },
    { value: "Øre-næse-hals kirurgi", label: "Øre-næse-hals kirurgi" },
  ];

  return (
    <div>
      <section className="md:h-screen">
        <div className="grid mx-auto h-full md:grid-cols-2">
          <div className="bg-white w-full container md:w-2/3 mx-auto md:py-6 order-2 md:order-1">
            <div className="header mt-2 hidden md:block flex items-center justify-between md:block">
              <button
                className="flex items-center md:mb-24"
                onClick={() => prevStep()}
              >
                <img src={backBtn} width={26} className="mr-3" alt="Tilbage" />
                <p className="text-doctio-green">Tilbage</p>
              </button>
              <img
                src={logo}
                width={150}
                className="md:mr-3 md:mb-20"
                alt="Logo"
              />
            </div>

            <h1 className="mt-10 mb-12 md:mt-0 font-bold leading-tight tracking-tight text-doctio-green text-d2xl">
              Lad os tilpasse din profil
            </h1>

            <form className="space-y-6 mt-8 signup-form md:space-y-6">
              <Select
                value={profession}
                onChange={(value) => handleInputChange(value)}
                options={professionOptions}
                placeholder="Fagprofil"
                isSearchable={true}
                searchInputPlaceholder="Søg efter fagprofil"
                noOptionsMessage="Ingen resultater fundet"
                primaryColor={"emerald"}
                classNames={{
                  searchIcon: "absolute w-5 h-5 pb-0.5 ml-2 text-gray-500",
                  searchContainer: "relative flex items-center py-1 px-2.5",
                  searchBox:
                    "w-full py-2 pl-8 text-dsm text-gray-500 bg-gray-100 border border-gray-200 rounded focus:border-gray-200 focus:ring-0 focus:outline-none",
                  menu: "absolute z-10 w-full bg-white shadow-lg border rounded py-1 mt-1.5 text-dsm text-gray-700",
                  menuButton: () =>
                    `flex text-dsm text-gray-500 border rounded shadow-sm transition-all duration-300 focus:outline-none bg-white hover:doctio-grey-border focus:border-blue-500 focus:ring focus:ring-blue-500/20"`,
                }}
              />

              <Select
                value={specialty}
                onChange={(value) => handleSpecialtyChange(value)}
                options={specialtyOptions}
                placeholder="Speciale"
                searchInputPlaceholder="Søg efter speciale"
                noOptionsMessage="Ingen resultater fundet"
                isSearchable={true}
                classNames={{
                  searchIcon: "absolute w-5 h-5 pb-0.5 ml-2 text-gray-500",
                  searchContainer: "relative flex items-center py-1 px-2.5",
                  searchBox:
                    "w-full py-2 pl-8 text-dsm text-gray-500 bg-gray-100 border border-gray-200 rounded focus:border-gray-200 focus:ring-0 focus:outline-none",
                  menu: "absolute z-10 w-full bg-white shadow-lg border rounded py-1 mt-1.5 text-dsm text-gray-700",
                  menuButton: () =>
                    `flex text-dsm text-gray-500 border rounded shadow-sm transition-all duration-300 focus:outline-none bg-white hover:doctio-grey-border focus:border-blue-500 focus:ring focus:ring-blue-500/20"`,
                }}
                primaryColor={"emerald"}
              />
            </form>

            <div className="checkboxes mt-16 space-y-4">
              <div className="flex items-center">
                <input
                  id="receive_newsletter"
                  name="receive_newsletter"
                  type="checkbox"
                  checked={signUpData.receive_newsletter}
                  onChange={handleCheckboxChange}
                  className="w-7 h-7 accent-green-800 rounded focus:ring-blue-500 "
                />
                <label
                  htmlFor="checked-checkbox"
                  className="ms-5 text-dsm italic font-medium"
                >
                  Tilmeld nyheder og opdateringer
                </label>
              </div>

              <div className="flex items-center">
                <input
                  id="confirm_health_professional"
                  name="confirm_health_professional"
                  type="checkbox"
                  checked={signUpData.confirm_health_professional}
                  onChange={handleCheckboxChange}
                  className="w-7 h-7 accent-green-800 rounded focus:ring-blue-500 "
                />
                <label
                  htmlFor="checked-checkbox"
                  className="ms-5 text-dsm italic font-medium"
                >
                  Jeg bekræfter jeg er sundhedsproffesionel
                </label>
              </div>

              <div className="flex items-center">
                <input
                  id="accept_terms_condition"
                  name="accept_terms_condition"
                  type="checkbox"
                  checked={signUpData.accept_terms_condition}
                  onChange={handleCheckboxChange}
                  className="w-7 h-7 accent-green-800 rounded focus:ring-blue-500 "
                />
                <label
                  htmlFor="checked-checkbox"
                  className="ms-5 text-dsm italic font-medium"
                >
                  Accepterer{" "}
                  <a href="/disclaimer" className="text-doctio-green underline">
                    brugervilkår
                  </a>
                  ,{" "}
                  <a className="text-doctio-green underline" href="/persondata">
                    persondatapolitik
                  </a>{" "}
                  og{" "}
                  <a href="/disclaimer" className="text-doctio-green underline">
                    privatlivspolitik
                  </a>
                </label>
              </div>
            </div>

            <button
              type="button"
              onClick={onClickNext}
              disabled={!isFormValid || isSigningUp}
              className={`text-white transition-colors mt-10 w-full duration-300 ease-in-out font-bold rounded-full bg-doctio-green ${
                !isFormValid
                  ? "opacity-60"
                  : "hover:bg-white hover:text-doctio-green hover:shadow-md"
              } focus:ring-4 focus:outline-none px-4 py-4 text-center mr-3 md:mr-0`}
            >
              Næste
            </button>

            <div className="mt-6">
              <p className="italic text-dsm">
                Vi deler ikke dine kontaktinformationer med tredjepart.
              </p>
            </div>
          </div>

          <div className="relative mx-auto w-full container md:max-w-none md:bg-doctio-lightgreen md:py-40 md:h-screen order-1 md:order-2 overflow-hidden">
            <div className="shadow-right"></div>
            <div className="md:w-2/3 mx-auto">
              <div className="image-container relative">
                <div className="header mt-6 mb-6 md:hidden flex items-center justify-between md:block">
                  <Link to="/">
                    <img
                      src={logo}
                      width={150}
                      className="md:mr-3 md:mb-20 w-[120px] md:w-[150px]"
                      alt="Logo"
                    />
                  </Link>
                  <button
                    className="flex items-center md:mb-8"
                    onClick={() => prevStep()}
                  >
                    <img
                      src={backBtn}
                      width={26}
                      className="mr-3"
                      alt="Tilbage"
                    />
                    <p className="text-doctio-green">Tilbage</p>
                  </button>
                </div>
                <img
                  src={læge}
                  className="mr-3 h-96 object-cover md:h-auto w-full md:object-fit picture-shadow rounded-3xl"
                  alt="Læge"
                />

                <div className="mt-12 mb-10 hidden md:block">
                  <p className="leading-tight tracking-tight">
                    <span className="font-bold">Navn Navnesen</span>, Titel lige
                    her, Hospitalsnavn.
                  </p>
                  <p className="mt-2 italic">Bruger af Doctio</p>
                </div>

                <div className="absolute hidden md:block frase-ikon-sign left-[-95px] top-[40%]">
                  <img
                    src={fraseIkon}
                    width={199}
                    className="mr-3"
                    alt="Tilbage"
                  />
                </div>
              </div>
              <Stats data={statsData} />
            </div>
          </div>
        </div>
        <ToastContainer />
      </section>
    </div>
  );
}
